export const SET_LIVES = '[LIVES] SET_LIVES';
